"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendTypingIndicator;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useSendTypingIndicator() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var sendTypingIndicator = _ref.sendTypingIndicator;
    return sendTypingIndicator;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kVHlwaW5nSW5kaWNhdG9yLnRzIl0sIm5hbWVzIjpbInVzZVNlbmRUeXBpbmdJbmRpY2F0b3IiLCJzZW5kVHlwaW5nSW5kaWNhdG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0Esc0JBQVQsR0FBNkM7QUFDMUQsU0FBTyxDQUFDLHNDQUFZO0FBQUEsUUFBR0MsbUJBQUgsUUFBR0EsbUJBQUg7QUFBQSxXQUE2QkEsbUJBQTdCO0FBQUEsR0FBWixDQUFELENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZW5kVHlwaW5nSW5kaWNhdG9yKCk6IFtib29sZWFuXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgc2VuZFR5cGluZ0luZGljYXRvciB9KSA9PiBzZW5kVHlwaW5nSW5kaWNhdG9yKV07XG59XG4iXX0=